import { render, staticRenderFns } from "./GoalEditSheetContainer.vue?vue&type=template&id=1b81a6fa&"
import script from "./GoalEditSheetContainer.vue?vue&type=script&lang=js&"
export * from "./GoalEditSheetContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports